<template>
  <!--Buscador general, el input se busca en multiples campos-->
  <v-row class="ma-0" justify="end">
    <v-col style="padding-top: 0;padding-bottom: 0" cols="0" sm="0" lg="6"></v-col>
    <v-col style="padding-top: 0;padding-bottom: 0" cols="4" sm="12" lg="4">
      <v-card elevation="2" style="margin-bottom: 0;border-radius: 0;">
        <v-card-actions>
          <v-text-field
              id="buscador_tabla"
              :label="label"
              v-model="text"
              dense
              outlined
              hide-details
              clearable
              @click:clear="$emit('search_general', '')"
          ></v-text-field>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "BuscadorTabla",

  props:['label',],

  data: () => ({
    contador: null,
    tiempo_espera: 500,
    text: null
  }),

  methods: {
    /**
     * Lanza el evento cuando el usuario ha parado de escribir durante el tiempo de espera.
     */
    fin_de_escritura() {
      this.$emit('search_general', this.text)
    }
  },

  mounted() {
    // Buscamos el input en el DOM
    const input = document.getElementById('buscador_tabla')

    // Al dejar de escribir, inicializamos el contador
    input.addEventListener('keyup', () => {
      clearTimeout(this.contador);
      this.contador = setTimeout(this.fin_de_escritura, this.tiempo_espera);
    });

    // Reiniciamos el contador al presionar una tecla
    input.addEventListener('keydown', () => {
      clearTimeout(this.contador);
    });
  }
}
</script>